/**
 * @description English UI text that lives in code, not Contentful. Keys are flat; `{{name}}` marks a value
 * passed to `t(key, { name })`. Every key here must exist in `fr.ts`, which type-check enforces.
 */
export const en = {
  'blog.minRead': '{{readTime}} min read',
  'blogCatalog.title': 'Blog catalog',
  'blogCatalog.categories': 'Blog categories',
  'blogCatalog.allBlogs': 'All Blogs',
  'blogCatalog.loadMore': 'Load More',
  'blogCatalog.loadedMore': 'Loaded {{count}} more blogs above',
  'blogCatalog.searchLabel': 'Search For a Keyword or Topic',
  'blogCatalog.searchResultsFor': 'Search Results For:',
  'blogCatalog.searchingWithin': 'Searching within',
  'blogCatalog.showingResultsFor': 'Showing results for',
  'blogCatalog.backToAllBlogs': '< Back to All Blogs',
  'creditCard.annualFee': 'Annual Fee',
  'creditCard.purchaseInterestRate': 'Purchase Interest Rate',
  'creditCard.cashAdvanceRate': 'Cash Advance Rate',
  'creditCard.balanceTransferRate': 'Balance Transfer Rate',
  'creditCard.notApplicable': 'N/A',
  'creditCard.viewProduct': 'View Product',
  'creditCard.viewProductFor': 'View Product {{productTitle}}',
  'creditCard.showDetails': 'Show Details',
  'creditCard.hideDetails': 'Hide Details',
  'creditCard.showDetailsFor': 'Show Details for {{productTitle}}',
  'creditCard.hideDetailsFor': 'Hide Details for {{productTitle}}',
  'creditCard.imageAlt': '{{productTitle}} credit card',
  'loan.provider': 'Provider',
  'loan.loanAmount': 'Loan Amount',
  'loan.interestRate': 'Interest Rate',
  'loan.term': 'Term',
  'loan.applyNow': 'Apply Now',
  'loan.applyNowFor': 'Apply now for {{companyName}} Loan',
  'personalLoanCalculator.infoTitle': 'Personal Loan Info',
  'personalLoanCalculator.amount': 'Amount',
  'personalLoanCalculator.amountError': 'Amount must be a positive number',
  'personalLoanCalculator.rate': 'Rate',
  'personalLoanCalculator.rateError': 'Rate must be a positive whole number',
  'personalLoanCalculator.loanTerm': 'Loan Term (Months)',
  'personalLoanCalculator.loanTermError': 'Loan term must be a positive whole number',
  'personalLoanCalculator.calculate': 'Calculate',
  'personalLoanCalculator.paymentTitle': 'Personal Loan Payment',
  'personalLoanCalculator.monthlyPayment': 'Monthly Payment',
  'personalLoanCalculator.interestCost': 'Interest Cost for Term',
  'personalLoanCalculator.announcement':
    'Monthly Payment: {{monthlyPayment}}\nInterest Cost for Term: {{interestCost}}',
  'header.menu': 'Menu',
  'header.close': 'Close',
  'header.openMenu': 'Open menu',
  'header.closeMenu': 'Close menu',
  'header.submenu': '{{linkText}} submenu',
  'icon.chevronDown': 'Chevron down',
  'icon.chevronUp': 'Chevron up',
  'icon.caretDown': 'Caret down',
  'icon.chevronThick': 'Chevron thick',
  'input.clearSearch': 'Clear search',
  'snackBar.dismiss': 'dismiss',
  'metadata.description': 'Borrowell helps Canadians make great decisions about credit.',
  'metadata.keywords':
    'equifax free report, credit rating canada, how to check credit score, annual credit report canada',
  'metadata.blogTitle': 'The Well- Personal Finance Blog',
  'metadata.blogDescription':
    'Get tips, tools and resources to improve your financial health and feel in control and optimistic about your future.',
  'metadata.blogKeywords': 'Borrowell blog, Personal Finance, Credit Score',
}

export type TranslationKey = keyof typeof en
